/* ============================================================
   YOLÈTE — Panier Shopify (thème uniquement).
   Chargé APRÈS common.js. Remplace le panier local par le panier
   Shopify (/cart/add.js, /cart.js, /cart/change.js) sans toucher
   à l'interface du tiroir. Sur le site Vercel ce fichier n'est pas
   chargé, le panier local de common.js reste actif.

   Règles :
   - une boucle = une variante Shopify (finition), ajoutée tout de suite ;
   - une tige = une variante (coloris × taille). Sans taille choisie,
     la ligne reste « en attente » dans le tiroir jusqu'au choix de la
     taille, puis part dans le panier Shopify ;
   - « Passer commande » ouvre /checkout dès qu'aucune ligne n'attend.
   ============================================================ */
(function () {
  if (!window.Shopify || !window.SHOP) return;

  /* ---------- produits Shopify indexés par handle ---------- */
  var BYH = {};
  /* 'sacs' ajouté le 25 sept 2026 : sans lui, un sac partait toujours au panier
     dans sa première variante, quel que soit le coloris ou l'anse choisis. */
  ['boucles40', 'boucles25', 'tiges40', 'tiges25', 'extra', 'tigesSite', 'sacs'].forEach(function (k) {
    (SHOP[k] || []).forEach(function (p) { BYH[p.handle] = p; });
  });

  /* identifiants du site -> produits Shopify (tiges). tiges-catalog.js publie
     la même table (window.TIGE_HANDLE), elle prime pour rester d'accord avec lui. */
  var TIGE_HANDLE = window.TIGE_HANDLE || {
    'preto':       { 40: '19840pr-copie', 25: 'preto' },
    'python':      { 40: 'python-1',      25: 'python' },
    'vintage':     { 40: 'vintage',       25: 'vintage-25' },
    'vintage-leo': { 40: 'vintage-leopard', 25: null }
  };
  var COLOR_VALUES = {
    black:  ['BLACK', 'NOIR'],
    brown:  ['DARK BROWN', 'BROWN', 'MARRON'],
    camel:  ['CAMEL'],
    havane: ['HAVANE']
  };
  var LABEL_VALUES = {
    'OR': ['OLD GOLD', 'GOLD', 'ORO', 'DORE'],
    'ARGENT': ['SILVER', 'ARGENT'],
    'DORE': ['OLD GOLD', 'GOLD'],
    'NOIR': ['BLACK', 'NOIR'], 'MARRON': ['DARK BROWN', 'BROWN'], 'CAMEL': ['CAMEL'], 'HAVANE': ['HAVANE']
  };
  function norm(s) { return String(s || '').trim().toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  /* Coloris d'une tige : valeurs Shopify acceptées. Un coloris ajouté par
     Charlotte (2 oct 2026) a pour clé son nom en minuscules (« navy »). */
  function valeursCouleur(cle) { return COLOR_VALUES[cle] || [String(cle || '').toUpperCase().replace(/-/g, ' ')]; }
  function cleCouleur(valeur) {
    var col = norm(valeur);
    for (var c in COLOR_VALUES) { if (COLOR_VALUES[c].indexOf(col) !== -1) return c; }
    return col.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  /* tige-preto-black-40 -> {leather, color, width}. Le cuir est cherché parmi
     ceux de TIGE_HANDLE, le plus long d'abord (vintage-leo avant vintage), si
     bien qu'un cuir ajouté par Charlotte (tige-savane-fauve-40) se lit aussi. */
  function parseTige(id) {
    var m = /^tige-(.+)-(40|25)$/.exec(id || ''); if (!m) return null;
    var reste = m[1], cuirs = Object.keys(window.TIGE_HANDLE || TIGE_HANDLE).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < cuirs.length; i++) {
      if (reste.indexOf(cuirs[i] + '-') === 0 && reste.length > cuirs[i].length + 1) return { leather: cuirs[i], color: reste.slice(cuirs[i].length + 1), width: +m[2] };
    }
    return null;
  }
  function tigeProduct(id) {
    var t = parseTige(id); if (!t) return null;
    var h = ((window.TIGE_HANDLE || TIGE_HANDLE)[t.leather] || {})[t.width];
    return h && BYH[h] ? { prod: BYH[h], tige: t } : null;
  }
  /* variante d'une tige pour un coloris du site et une taille */
  function tigeVariant(id, size) {
    var r = tigeProduct(id); if (!r) return null;
    var wanted = valeursCouleur(r.tige.color);
    var vs = r.prod.variants.filter(function (v) {
      var col = norm(v.option1), sz = String(v.option2 || '').replace(/\D/g, '');
      return wanted.indexOf(col) !== -1 && (!size || sz === String(size));
    });
    /* ordre de préférence des coloris : DARK BROWN avant BROWN pour le vintage, sinon le premier */
    vs.sort(function (a, b) { return wanted.indexOf(norm(a.option1)) - wanted.indexOf(norm(b.option1)); });
    return vs[0] || null;
  }
  /* stock d'un coloris de tige (somme des tailles). Les tiges sont faites à la commande :
     une taille à zéro se vend quand même, mais un coloris à zéro sur toutes les tailles est épuisé. */
  function tigeStock(id) {
    id = String(id || ''); if (!/^tige-/.test(id)) id = 'tige-' + id;
    var r = tigeProduct(id); if (!r) return null;
    var wanted = valeursCouleur(r.tige.color), known = false, total = 0;
    r.prod.variants.forEach(function (v) { if (wanted.indexOf(norm(v.option1)) === -1) return; if (typeof v.qty === 'number') { known = true; total += v.qty; } });
    return known ? total : null;
  }
  window.yoleteTigeStock = tigeStock;
  /* les fiches synthétiques des tiges prennent la disponibilité réelle de leur coloris */
  if (typeof PRODUCTS !== 'undefined') PRODUCTS.forEach(function (p) { if (p.type === 'tige') { var st = tigeStock(p.id); if (st !== null) p.available = st > 0; } });

  /* variante d'une boucle pour un libellé de finition (Or, Argent, Chorus…) */
  var SYN = { OR: 'GOLD', DORE: 'GOLD', DOREE: 'GOLD', GOLD: 'GOLD', ORO: 'GOLD', ARGENT: 'SILVER', ARGENTE: 'SILVER', ARGENTEE: 'SILVER', SILVER: 'SILVER', NOIR: 'BLACK', MARRON: 'BROWN' };
  /* Identite exacte d'une variante : toutes ses options sauf la largeur.
     « GOLD / CHORUS / 40MM » devient « GOLD / CHORUS ». */
  function optionKey(v) {
    return norm(v.title || '').replace(/\s*\/\s*\d+\s*MM\s*$/i, '').replace(/\s*\/\s*\d+\s*$/, '').trim();
  }
  /* Variante designee par la carte du composeur. Rend null si la boucle n'a pas
     cette option, pour qu'on retombe sur l'ancienne recherche. */
  function variantParOption(handle, option) {
    var p = BYH[handle]; if (!p || !option) return null;
    var cle = norm(option).replace(/\s*\/\s*\d+\s*MM\s*$/i, '').trim();
    var v = p.variants.filter(function (x) { return optionKey(x) === cle; })[0];
    if (v) return v;
    /* Finition renommée en la reliant aux couleurs Shopify (scripts/pastilles_boucles.py,
       28/10/2026) : les tables du composeur (cut-variantes.js) gardent l'ancien nom. */
    var ren = ((window.SHOP && SHOP.anciensColoris) || {})[handle] || {};
    for (var ancien in ren) {
      if (norm(ancien) !== cle) continue;
      var nouveau = norm(ren[ancien]);
      return p.variants.filter(function (x) { return optionKey(x) === nouveau; })[0] || null;
    }
    return null;
  }
  /* Modele d'une variante, finition du metal retiree : « GOLD / CHORUS » et
     « SILVER / CHORUS » sont la meme boucle, « GOLD / VALENTINE » non. */
  function modeleDe(k) {
    return k.replace(/\b(OLD|ANTIC|GOLD|SILVER|MAT)\b/g, '').replace(/\s*\/\s*/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function libelleFinition(k) {
    if (/SILVER/.test(k)) return 'argenté';
    if (/GOLD/.test(k)) return 'doré';
    return k.toLowerCase();
  }
  /* Variante a mettre au panier pour une carte du composeur.
     La variante exacte si elle est en stock. Sinon le meme modele dans une
     autre finition, et on le dit. Jamais un autre modele en silence. */
  function variantPourCarte(handle, option) {
    var p = BYH[handle]; if (!p) return null;
    var exacte = variantParOption(handle, option);
    if (!exacte) return null;
    if (exacte.available) return { v: exacte, change: '' };
    var modele = modeleDe(optionKey(exacte));
    var alt = p.variants.filter(function (v) { return v.available && modeleDe(optionKey(v)) === modele; })[0];
    return alt ? { v: alt, change: libelleFinition(optionKey(alt)) } : { v: null, change: '' };
  }
  /* Le composeur s'en sert pour retirer une carte epuisee. Deux cas :
     la carte designe une variante precise, on regarde ce modele ; sinon on
     regarde le produit entier. Une boucle sans aucune variante en stock ne
     doit plus apparaitre dans l'atelier. */
  window.yoleteBoucleOut = function (handle, option) {
    var r = variantPourCarte(handle, option);
    /* La carte montre une finition précise. Épuisée, la carte quitte l'atelier même si
       une autre finition reste en stock : le composeur n'a pas la photo de l'autre
       finition, le client recevrait une boucle différente de celle qu'il a composée.
       Constaté le 23/09/2026, N20 dorée à l'écran, argentée au panier, et le message
       d'avertissement effacé aussitôt par « Ceinture ajoutée ». */
    if (r) return !(r.v && !r.change);
    var p = BYH[handle];
    /* Boucle absente du catalogue en ligne, donc passee en brouillon ou
       retiree du canal de vente : elle n'est pas achetable, elle n'a rien a
       faire dans l'atelier. Le test sur BYH evite de vider le composeur
       quand le catalogue Shopify n'est pas charge, comme sur la copie Vercel. */
    if (!p) return Object.keys(BYH).length > 0;
    if (!p.variants.length) return false;
    return !p.variants.some(function (v) { return v.available; });
  };
  /* « Ceinture en cuir Preto · 40 mm » (titre Shopify depuis le 17 sept 2026)
     ou « PRETO 25mm » (ancien titre) -> « Preto », pour la ligne du panier. */
  /* Nom court d'une boucle dans le tiroir. Le titre Shopify est long parce
     qu'il est ecrit pour Google, la ligne du panier doit rester « Boucle N01 ».
     codeBoucle vient de data-shopify.js et lit la reference, sinon le titre. */
  function boucleNom(it) {
    var c = window.codeBoucle ? codeBoucle(it.sku, it.product_title) : '';
    return c ? 'Boucle ' + c : String(it.product_title || '').replace(/^BOUCLE\s+/i, 'Boucle ');
  }
  /* Adresse de la fiche d'un article du panier. Une boucle mène à sa fiche
     Shopify, une tige à la fiche du site correspondant à SON coloris : la page
     native d'une famille de cuir ouvre sur le premier coloris, pas forcément
     celui du panier. productHref (common.js) choisit la bonne forme d'adresse. */
  function idSiteTige(handle, couleur) {
    var cible = cleCouleur(couleur);
    if (!cible) return '';
    var TH = window.TIGE_HANDLE || TIGE_HANDLE;
    for (var cuir in TH) {
      for (var w in TH[cuir]) { if (TH[cuir][w] === handle) return 'tige-' + cuir + '-' + cible + '-' + w; }
    }
    return '';
  }
  function lienFiche(id) {
    if (!id || typeof productHref !== 'function') return '';
    try { return productHref(id); } catch (e) { return ''; }
  }
  function lienLigne(it, tige) {
    if (!it || !it.handle) return '';
    if (tige) {
      var o = (it.options_with_values || []).filter(function (x) { return /couleur/i.test(x.name); })[0];
      var sid = idSiteTige(it.handle, o && o.value);
      if (sid) return lienFiche(sid);
    }
    return lienFiche(it.handle);
  }
  function tigeFamille(t) {
    return String(t || '').replace(/^Ceinture en cuir\s+/i, '').replace(/\s*·\s*\d+\s*mm$/i, '').replace(/\s*\d+\s*mm$/i, '').trim();
  }
  function boucleVariant(handle, label) {
    var p = BYH[handle]; if (!p || !p.variants.length) return null;
    var L = norm(label).split('·')[0].trim();
    var wanted = LABEL_VALUES[L] || (L ? [L] : []);
    var exact = [], partial = [];
    if (wanted.length) {
      exact = p.variants.filter(function (v) { return wanted.indexOf(norm(v.option1)) !== -1; });
      partial = p.variants.filter(function (v) { return wanted.some(function (w) { return norm(v.option1).indexOf(w) !== -1; }); });
    }
    /* par jetons : « Chorus argent » = tous les mots (traduits) présents dans le nom de la variante */
    if (!exact.length && !partial.length && L) {
      var toks = L.split(/[^A-Z0-9]+/).filter(Boolean).map(function (t) { return SYN[t] || t; });
      partial = p.variants.filter(function (v) { var n = norm(v.option1); return toks.every(function (t) { return n.indexOf(t) !== -1; }); });
    }
    /* parmi les finitions correspondantes, d'abord celles en stock */
    var pool = exact.length ? exact : partial;
    return pool.find(function (v) { return v.available; }) || pool[0] || p.variants.find(function (v) { return v.available; }) || p.variants[0];
  }

  /* ---------- état ---------- */
  var items = [];      /* lignes du panier Shopify (/cart.js) */
  var pending = [];    /* tiges en attente de taille (locales) */
  var provisoires = []; /* lignes affichées avant la réponse de Shopify (voir addVariants) */
  var cartToken = '';  /* identifiant du panier de la session, lu dans /cart.js */
  var drawerItems = document.getElementById('drawerItems');
  var drawerFoot = document.getElementById('drawerFoot');
  var drawerTotal = document.getElementById('drawerTotal');
  var cartCount = document.getElementById('cartCount');
  var SIZES = (typeof TAILLES_TIGE !== 'undefined') ? TAILLES_TIGE : ['75', '80', '85', '90', '95', '100', '105', '110'];

  function api(path, body, retry) {
    return fetch(path, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: body ? JSON.stringify(body) : undefined, credentials: 'same-origin' })
      .then(function (r) {
        return r.text().then(function (t) {
          var j = null; try { j = JSON.parse(t); } catch (e) {}
          if (r.status === 429 && !retry) { return new Promise(function (res) { setTimeout(res, 1500); }).then(function () { return api(path, body, true); }); }
          if (!r.ok || !j) { console.error('Panier Shopify', path, r.status, t.slice(0, 200)); throw (j || { status: r.status, description: (r.status === 429 ? 'Shopify vérifie votre navigateur, réessayez dans un instant' : 'Erreur ' + r.status + ' au panier') }); }
          return j;
        });
      });
  }
  /* `apres` s'exécute une fois le panier relu, juste avant le rendu : c'est là
     que les lignes provisoires s'effacent, remplacées par les vraies. Les appels
     en `.then(refresh)` reçoivent la réponse de Shopify à sa place, d'où le
     test sur le type. */
  function refresh(apres) {
    var fin = (typeof apres === 'function') ? apres : null;
    return api('/cart.js').then(function (c) {
      items = c.items || []; cartToken = String(c.token || '').split('?')[0];
      if (fin) fin();
      render(); refreshExpress();
    }).catch(function () { if (fin) fin(); render(); });
  }
  /* Les boutons express (Shop Pay, Apple Pay, PayPal) sont rendus par Liquid pour
     le panier de la session, repéré par son identifiant (attribut cart-id). Tant
     que le panier garde cet identifiant, ils restent valables : au clic, ils
     relisent le panier chez Shopify. On ne recharge donc la page que quand le
     bloc porte un autre panier ou n'en porte pas (première visite, panier créé
     à l'instant), une seule fois par panier. Avant, chaque changement rechargeait
     la page entière, 40 Ko et jusqu'à une seconde, et réinitialisait Shop Pay et
     PayPal à chaque fois. */
  var exTimer = null, expressDemandePour = '';
  function expressAJour() {
    var ex = document.getElementById('yolete-express'), w = ex && ex.querySelector('[cart-id]');
    return !!(w && cartToken && w.getAttribute('cart-id') === cartToken);
  }
  function refreshExpress() {
    if (!items.length || expressAJour() || expressDemandePour === cartToken) return;
    clearTimeout(exTimer);
    exTimer = setTimeout(function () {
      var pour = cartToken;
      fetch(location.pathname + location.search, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('yolete-express'); var cur = document.getElementById('yolete-express');
        expressDemandePour = pour;
        if (!fresh || !cur) return;
        cur.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    }, 250);
  }
  /* Ligne du tiroir construite depuis le catalogue pour une variante, affichée
     tout de suite puis remplacée par la ligne Shopify : même titre, même
     vignette, même prix, le remplacement ne se voit pas. */
  function ligneProvisoire(handle, v, qty) {
    var p = BYH[handle]; if (!p || !v) return null;
    var cents = Math.round(Number(v.price || p.price || 0) * 100), q = qty || 1, noms = p.options || [];
    return {
      key: 'prov|' + v.id + '|' + Date.now(), provisoire: true,
      handle: handle, product_title: p.title, product_type: p.type || '', variant_id: v.id,
      variant_title: v.title || '', sku: v.sku || '',
      image: v.image || (p.images && p.images[0]) || '',
      quantity: q, price: cents, final_line_price: cents * q,
      options_with_values: [{ name: noms[0] || 'Couleur', value: v.option1 }, { name: noms[1] || 'Taille', value: v.option2 }]
        .filter(function (o) { return o.value !== null && o.value !== undefined && o.value !== ''; })
    };
  }
  /* Lignes à afficher : les vraies, plus les provisoires. Une provisoire dont
     la variante est déjà au panier s'ajoute à la quantité de cette ligne, comme
     Shopify le fera ; les autres passent en tête, où Shopify met les nouveautés.
     Une provisoire porte l'indice -1 : ses boutons restent inertes le temps
     de la réponse, quelques centaines de millisecondes. */
  function vue() {
    var lignes = items.map(function (it, i) { return { it: it, i: i }; }), nouvelles = [];
    provisoires.forEach(function (pv) {
      var ex = lignes.concat(nouvelles).filter(function (l) { return l.it.variant_id === pv.variant_id; })[0];
      if (ex) {
        var c = Object.assign({}, ex.it), unit = ex.it.final_line_price / (ex.it.quantity || 1);
        c.quantity = ex.it.quantity + pv.quantity; c.final_line_price = Math.round(unit * c.quantity); ex.it = c;
      } else nouvelles.unshift({ it: pv, i: -1 });
    });
    return nouvelles.concat(lignes);
  }
  /* Un seul appel à /cart/add.js pour toutes les lignes : la tige et la boucle
     d'une ceinture composée partaient en deux requêtes en série, et le tiroir
     s'ouvrait vide pendant 0,7 s avant de se remplir en deux temps (1,1 s en
     tout, mesuré le 20 sept 2026). Les lignes s'affichent maintenant tout de
     suite, depuis le catalogue, et la réponse de Shopify les remplace. Les
     appels restent en file : deux requêtes simultanées sur /cart/add.js
     perdaient une ligne (vu en préprod le 18 sept 2026). */
  var fileAjout = Promise.resolve();
  function addVariants(list) {
    var provs = list.map(function (l) { return l.prov; }).filter(Boolean);
    provs.forEach(function (pv) { provisoires.push(pv); });
    render();
    function retirer() { provisoires = provisoires.filter(function (pv) { return provs.indexOf(pv) === -1; }); }
    var p = fileAjout.then(function () {
      return api('/cart/add.js', { items: list.map(function (l) {
        var o = { id: l.id, quantity: l.qty || 1 };
        if (l.props) o.properties = l.props;   /* ex. précommande, visible jusqu'à la commande */
        return o;
      }) })
        .then(function () { return refresh(retirer); }, function (err) { retirer(); refresh(); throw err; });
    });
    fileAjout = p.catch(function () {});
    return p;
  }
  function addVariant(variantId, qty, prov) { return addVariants([{ id: variantId, qty: qty, prov: prov }]); }
  function removeKey(key) { return api('/cart/change.js', { id: key, quantity: 0 }).then(refresh); }
  function say(msg) { if (typeof toast === 'function') toast(msg); }
  function open_() { if (typeof openDrawer === 'function') openDrawer(); }
  /* Ajout d'une variante seule, hors catalogue du site (carte cadeau, 2 nov 2026),
     dans la même file que les autres ajouts. */
  window.ajouterVariante = function (variantId, nom) {
    var accord = /^carte/i.test(nom || '') ? ' ajoutée au panier' : ' ajouté au panier';
    return addVariants([{ id: variantId, qty: 1 }]).then(function () { say((nom || 'Article') + accord); open_(); },
      function (e) { say(e && e.description ? e.description : 'Article indisponible'); });
  };

  /* ---------- API attendue par common.js / produit.js / personnalisation.js ---------- */
  window.addToCart = function (id, variant) {
    var label = (variant && variant.label) || '';
    var p = (typeof PRODUCTS !== 'undefined') ? PRODUCTS.find(function (x) { return x.id === id; }) : null;
    if (p && p.type === 'tige') {
      var nomTige = p.name + (p.colorLabel ? ' ' + p.colorLabel : '');
      var m = /\bT(\d{2,3})\b/.exec(label); var size = m ? m[1] : null;
      var v = size ? tigeVariant(id, size) : null;
      if (v) {
        var tp = tigeProduct(id);
        addVariant(v.id, 1, tp ? ligneProvisoire(tp.prod.handle, v) : null).then(function () { say(nomTige + ' · taille ' + size + ' ajoutée au panier'); open_(); })
          .catch(function (e) { say(e && e.description ? e.description : 'Article indisponible dans cette taille'); });
      } else {
        pending.push({ id: id, name: p.name, price: p.price, img: (variant && variant.img) || p.img, vlabel: label.replace(/\s*·\s*T\d+/, ''), key: 'pend|' + id + '|' + Date.now() });
        render(); say(nomTige + ' ajoutée, choisissez la taille'); open_();
      }
      return;
    }
    /* La pastille de la fiche nomme parfois la variante Shopify exacte, comme
       le fait la carte du composeur. C'est le seul repère sûr quand une option
       mélange deux choses : sur la N27, « Noir » désigne les pierres, et la
       recherche par étiquette tombait sur « OLD GOLD - PIERRES BLACK ». */
    /* Coloris choisi épuisé : on le dit et on n'ajoute rien (3 nov 2026). Avant, la même
       boucle partait au panier dans l'autre finition : N20 or épuisée, l'argentée ajoutée
       depuis la boutique, et l'avertissement aussitôt remplacé par « ajouté au panier ». */
    var EPUISE = (p && p.type === 'boucle' ? 'Cette boucle' : 'Cet article') + ' n’est plus disponible dans ce coloris';
    var vo = (variant && variant.voption) ? variantPourCarte(id, variant.voption) : null;
    if (vo && (!vo.v || vo.change)) { say(EPUISE); return; }
    var v2 = (vo && vo.v) || boucleVariant(id, label) || (p && p.variantId ? { id: p.variantId } : null);
    if (!v2) { say('Cet article n’est pas encore disponible à la vente'); return; }
    var vb = v2.title ? v2 : ((BYH[id] || { variants: [] }).variants.filter(function (x) { return x.id === v2.id; })[0] || null);
    /* Sans repère exact, boucleVariant rend le coloris demandé même épuisé : Shopify le
       refuserait avec un message moins clair. */
    if (vb && vb.available === false) { say(EPUISE); return; }
    /* Pièce en précommande : la mention suit la ligne jusqu'au paiement, dans
       l'e-mail de confirmation et dans la commande de l'admin (25 sept 2026). */
    var pre = (p && p.precommande) ? { 'Précommande': String(p.precommande).replace(/^pr[ée]commande\s*[,·]?\s*/i, '') || String(p.precommande) } : null;
    addVariants([{ id: v2.id, qty: 1, prov: ligneProvisoire(id, vb), props: pre }]).then(function () { say(((p && p.name) || 'Article') + (label ? ' · ' + label : '') + ' ajouté au panier'); open_(); })
      .catch(function (e) { say(e && e.description ? e.description : 'Article indisponible'); });
  };
  /* Une ligne du composeur -> ce qu'il faut envoyer à Shopify :
     { id, qty, prov } pour une variante, { pending } pour une tige dont la
     taille n'existe pas, { erreur } avec le message quand rien n'est vendable. */
  function resoudre(line) {
    if (line.type === 'tige') {
      /* Taille choisie dans le composeur (18 sept 2026) : la tige part tout de
         suite en ligne Shopify, sans ligne « en attente » ni bouton grisé. */
      var tid = line.id.indexOf('tige-') === 0 ? line.id : 'tige-' + line.id;
      if (line.size) {
        var tv = tigeVariant(tid, String(line.size)), tp = tigeProduct(tid);
        if (tv) return { id: tv.id, qty: 1, prov: tp ? ligneProvisoire(tp.prod.handle, tv) : null };
      }
      return { pending: { id: tid, name: line.name, price: line.price, img: line.img, vlabel: line.vlabel || '', key: 'pend|' + line.id + '|' + Date.now() } };
    }
    /* Le composeur transmet la variante exacte de sa carte. Sans elle, on
       retombait sur la premiere variante en stock, donc parfois un autre
       modele : une Valentine ajoutee a la place d'une Chorus. */
    var r = variantPourCarte(line.id, line.voption || line.color || '');
    var v = r && r.v;
    if (r && !v) return { erreur: 'Cette boucle est épuisée pour le moment' };
    /* Jamais une autre finition que celle de l'image composée (voir yoleteBoucleOut). */
    if (r && r.change) return { erreur: 'Cette finition est épuisée pour le moment' };
    var note = '';
    if (!v) v = boucleVariant(line.id, line.color || (line.vlabel && /mm/.test(line.vlabel) ? '' : line.vlabel));
    if (!v) return { erreur: 'Boucle indisponible à la vente pour le moment' };
    return { id: v.id, qty: 1, prov: ligneProvisoire(line.id, v), note: note };
  }
  /* Envoi groupé. Une ligne invendable bloque tout le lot : une ceinture sans
     sa boucle, ou sans sa tige, n'a rien à faire au panier. Rend false dans ce
     cas, pour que l'appelant n'annonce pas une ceinture ajoutée. */
  function envoyer(res) {
    var erreurs = res.filter(function (r) { return r.erreur; });
    if (erreurs.length) { say(erreurs[0].erreur); return false; }
    res.forEach(function (r) { if (r.note) say(r.note); if (r.pending) pending.push(r.pending); });
    var envoi = res.filter(function (r) { return r.id; });
    if (envoi.length) addVariants(envoi).catch(function (e) { say(e && e.description ? e.description : 'Article indisponible'); });
    else render();
    return true;
  }
  var lot = null;   /* lignes en cours de regroupement, voir cartAddLines */
  window.cartAdd = function (line) {
    var r = resoudre(line);
    if (lot) { lot.push(r); return; }
    return envoyer([r]);
  };
  /* Composeur : la tige et la boucle en une seule requête. Chaque ligne repasse
     par window.cartAdd, que analytics.js enveloppe pour compter les ajouts. */
  window.cartAddLines = function (lines) {
    var res;
    lot = [];
    try { lines.forEach(function (l) { window.cartAdd(l); }); } finally { res = lot; lot = null; }
    return envoyer(res);
  };
  window.removeFromCart = function (i) {
    if (!(i >= 0)) return;   /* ligne provisoire (indice -1) : rien à retirer côté Shopify */
    if (i < items.length) removeKey(items[i].key);
    else { pending.splice(i - items.length, 1); render(); }
  };
  window.renderCart = render;

  /* ---------- rendu du tiroir ---------- */
  function euro_(n) { return (typeof euro === 'function') ? euro(n) : (n.toFixed(2).replace('.', ',') + ' €'); }
  function sizeOf(it) {
    var o = (it.options_with_values || []).find(function (x) { return /taille/i.test(x.name); });
    return o ? String(o.value).replace(/\D/g, '') : '';
  }
  /* Une tige a une option Taille numérique (75 à 115). Une boucle a « 40MM » ou « 25MM ». */
  function isTige(it) {
    if (/tige|ceinture/i.test(it.product_type || '') && !/boucle/i.test(it.product_type || '')) return true;
    var sz = sizeOf(it); return !!sz && +sz >= 60;
  }
  /* tailles en stock : pour une tige du site (id) ou une ligne Shopify (handle + coloris) */
  function availableSizes(siteId, handle, colour) {
    var vs = [];
    if (siteId) { var r = tigeProduct(siteId); if (r) { var wanted = COLOR_VALUES[r.tige.color] || []; vs = r.prod.variants.filter(function (v) { return wanted.indexOf(norm(v.option1)) !== -1; }); } }
    else if (handle && BYH[handle]) { vs = BYH[handle].variants.filter(function (v) { return norm(v.option1) === norm(colour); }); }
    var ok = {}, known = false, total = 0;
    vs.forEach(function (v) { if (typeof v.qty === 'number') { known = true; total += v.qty; } });
    if (known && total <= 0) return { __none: 1 };   /* coloris épuisé : toutes les tailles bloquées */
    vs.forEach(function (v) { if (v.available) ok[String(v.option2 || '').replace(/\D/g, '')] = 1; });
    return ok;
  }
  function sizeSelect(idx, size, avail) {
    var known = avail && Object.keys(avail).length;
    /* Tant que la taille manque, la ligne est mise en avant : c'est elle qui
       bloque le bouton de commande apres un ajout depuis le composeur. */
    return '<label class="dl-size-wrap' + (size ? '' : ' dl-size-todo') + '"><select class="dl-size" data-size-for="' + idx + '" aria-label="Taille de la tige"><option value="">Votre taille</option>' +
      SIZES.map(function (s) {
        var out = known && !avail[s] && String(size) !== s;
        return '<option value="' + s + '"' + (String(size) === s ? ' selected' : '') + (out ? ' disabled' : '') + '>Taille ' + s + (out ? ' · épuisée' : '') + '</option>';
      }).join('') +
      '</select>' + (size ? '' : '<span class="dl-size-hint">Choisissez votre taille pour valider le panier</span>') + '</label>';
  }
  /* Seuil de la livraison offerte : réglage du thème (Personnaliser, Paramètres du thème,
     Yolète, Livraison), posé par le layout. 99 € sur la copie de travail. */
  var FRANCO = +window.YOLETE_FRANCO || 99;
  var head = document.querySelector('.drawer-head h3');
  function euroTxt(n) { return euro_(n); }
  function qtyCtl(i, q) { return '<span class="dl-qty"><button type="button" data-qd="' + i + '" data-d="-1" aria-label="Moins">−</button><output>' + q + '</output><button type="button" data-qd="' + i + '" data-d="1" aria-label="Plus">+</button></span>'; }
  /* Vignette détourée et centrée (cart-thumbs.js). Pour une boucle, on part de
     la photo du site correspondant à la finition choisie, sinon de l'image
     Shopify de la ligne. */
  /* Famille de finition. Shopify nomme ses variantes en anglais (OLD GOLD,
     SILVER), le site nomme ses pastilles en francais (Or, Argent) : sans ce
     rapprochement, une boucle argent arrivait au panier en photo doree. */
  function famille(txt) {
    var t = String(txt || '').toUpperCase();
    if (/ARGENT|SILVER|NICKEL|CHROME|PALLADIUM|ACIER/.test(t)) return 'argent';
    if (/\bOR\b|DOR|GOLD|LAITON|BRONZE|BRASS|CUIVRE/.test(t)) return 'or';
    if (/NOIR|BLACK/.test(t)) return 'noir';
    return '';
  }
  /* Decoupe transparente du composeur. Elle existe pour toutes les boucles de
     l'atelier, y compris celles sans photo boutique detouree : c'est ce qui
     evite le fond blanc quand la boucle est ajoutee depuis le composeur. */
  function cutThumb(handle, vt) {
    var C = window.BOUCLE_CUTOUTS;
    var connue = C && (Array.isArray(C) ? C.indexOf(handle) >= 0
                                        : Object.prototype.hasOwnProperty.call(C, handle));
    if (!connue) return '';
    var cols = (window.BOUCLE_COLORIS || {})[handle] || [], f = famille(vt), m = null, i;
    var VT = String(vt || '').toUpperCase();
    for (i = 0; i < cols.length; i++) {
      if (cols[i].c && VT.indexOf(String(cols[i].c).toUpperCase()) >= 0) { m = cols[i]; break; }
    }
    if (!m && f) for (i = 0; i < cols.length; i++) {
      if (famille(cols[i].c) === f || famille(cols[i].l) === f) { m = cols[i]; break; }
    }
    if (!m) m = cols[0];
    return `https://cdn.shopify.com/s/files/1/0790/8714/1213/files/cut__boucles__${handle}${(m && m.s) || ''}.png`;
  }
  /* Tige : la photo de la ligne Shopify est celle de la famille (toutes les
     couleurs sur une image). On montre le cuir de la ligne, dans sa couleur et sa
     largeur, avec la découpe du composeur (signalé par Nathan le 20 sept 2026). */
  function beltThumb(handle, it) {
    var leather = null, width = null, L, W, k;
    for (L in TIGE_HANDLE) for (W in TIGE_HANDLE[L]) if (TIGE_HANDLE[L][W] === handle) { leather = L; width = W; }
    if (!leather) return '';
    var opt = (it.options_with_values || []).filter(function (o) { return /couleur|colou?r/i.test(o.name); })[0];
    var val = norm(opt && opt.value), color = null;
    for (k in COLOR_VALUES) if (COLOR_VALUES[k].indexOf(val) !== -1) color = k;
    if (!color) return '';
    var id = leather + '-' + color + '-' + width;
    var B = (window.COMPOSER_BELTS || []).filter(function (b) { return b.id === id; })[0];
    return (B && B.img) || ('https://cdn.shopify.com/s/files/1/0790/8714/1213/files/cut__belts__' + id + '.png');
  }
  var NOMS_MARO = { ariane: 'Sac Ariane', angele: 'Sac Angèle', alina: 'Sac Alina', astrid: 'Sac Astrid',
                   bella40: 'Anse Bella 40 mm', bella25: 'Anse Bella 25 mm' };
  function lineThumb(it) {
    var src = it.image || '', vt = it.variant_title || '', handle = it.handle || '';
    /* Maroquinerie : le détouré haute définition du site plutôt que l'image Shopify */
    if (NOMS_MARO[handle]) { var mp = (window.PRODUCTS || []).filter(function (p) { return p.id === handle; })[0]; if (mp && mp.img) return mp.img; }
    if (isTige(it)) { var bt = beltThumb(handle, it); if (bt) return bt; }
    var sp = (window.PRODUCTS || []).filter(function (p) { return p.id === handle; })[0];
    if ((sp && sp.type === 'boucle') || /^boucle/i.test(handle)) {
      var sw = (window.BOUCLE_SWATCHES || {})[handle], f = famille(vt), photo = '';
      if (sw) {
        var lot = sw.swatches || [];
        /* Option de la ligne, largeur retirée : « SILVER - PIERRES BLACK / 40MM »
           devient « SILVER - PIERRES BLACK ». Une pastille qui nomme cette
           variante gagne sur la recherche par famille de métal, qui ne sait pas
           départager deux finitions argentées. */
        var opt = norm(vt).replace(/\s*\/\s*\d+\s*MM\s*$/i, '').replace(/\s*\/\s*\d+\s*$/, '').trim();
        var m = (opt && lot.filter(function (s) { return s.voption && norm(s.voption) === opt; })[0])
             || (f && lot.filter(function (s) { return famille(s.label) === f; })[0])
             || lot.filter(function (s) { return s.label && vt.toLowerCase().indexOf(s.label.toLowerCase()) >= 0; })[0];
        photo = (m && (m.photo || m.img)) || sw.default_photo || '';
      }
      /* cartThumb ne renvoie autre chose que son entree que s'il a trouve une
         vignette detouree : c'est le test qui distingue les deux cas. */
      var vign = photo && window.cartThumb ? cartThumb(photo) : photo;
      if (vign && vign !== photo) return vign;
      var cut = cutThumb(handle, vt);
      if (cut) return cut;
      if (vign) return vign;
    }
    return window.cartThumb ? cartThumb(src) : src;
  }
  function render() {
    if (!drawerItems) return;
    var lignes = vue();
    var count = lignes.reduce(function (s, l) { return s + l.it.quantity; }, 0) + pending.length;
    if (cartCount) { cartCount.textContent = count; cartCount.hidden = count === 0; }
    if (head) head.innerHTML = 'Panier' + (count ? ' <span class="n">· ' + count + '</span>' : '');
    if (!lignes.length && !pending.length) {
      drawerItems.innerHTML = '<div class="drawer-empty">Votre panier est vide.<br>Composez votre première ceinture.</div>';
      if (drawerFoot) drawerFoot.hidden = true; return;
    }
    var sub = lignes.reduce(function (s, l) { return s + l.it.final_line_price / 100; }, 0) + pending.reduce(function (s, p) { return s + p.price; }, 0);
    /* Livraison offerte : la carte cadeau ne compte pas, comme au paiement Shopify (testé le
       3 nov 2026 : boucle 59,90 € + carte 50 €, Colissimo 7,90 € facturé). Sans rien à
       expédier (carte seule), pas de barre : il n'y a pas de livraison. */
    var aExpedier = lignes.filter(function (l) { return !l.it.gift_card; });
    var subLivr = aExpedier.reduce(function (s, l) { return s + l.it.final_line_price / 100; }, 0) + pending.reduce(function (s, p) { return s + p.price; }, 0);
    var miss = Math.max(0, FRANCO - subLivr), pct = Math.min(100, subLivr / FRANCO * 100);
    var ship = (!aExpedier.length && !pending.length) ? '' : '<div class="dl-ship">' + (miss > 0 ? 'Plus que <b>' + euroTxt(miss) + '</b> avant la livraison offerte' : '<b>Livraison offerte</b>') + '<div class="bar"><i style="width:' + pct + '%"></i></div></div>';
    var html = lignes.map(function (l) {
      var it = l.it, i = l.i;
      var tige = isTige(it), size = sizeOf(it);
      /* filet de securite : si la decoupe manque sur les Fichiers Shopify,
         on retombe sur la photo de la ligne plutot que sur une image cassee */
      var img = it.image ? '<img class="dl-thumb dl-' + (tige ? 'tige' : 'boucle') + '" src="' + lineThumb(it)
        + '" onerror="this.onerror=null;this.src=\'' + it.image + '\'" alt="' + it.product_title + '">' : '';
      /* Une ligne provisoire (indice -1) n'est pas encore confirmée par Shopify :
         on ne propose pas de quitter la page tant que l'ajout est en route. */
      var href = (i >= 0) ? lienLigne(it, tige) : '';
      var ouvre = href ? '<a class="dl-fiche" href="' + href + '">' : '', ferme = href ? '</a>' : '';
      var vt = it.variant_title && it.variant_title !== 'Default Title' ? ' <span class="dl-variant">' + it.variant_title.replace(/\s*\/\s*\d+\s*(MM)?$/i, '').replace(/\s*\/\s*\d+$/, '').replace(/\s*\/\s*/g, ' · ').toLowerCase().replace(/(^|\s)\S/g, function (c) { return c.toUpperCase(); }) + '</span>' : '';
      /* Maroquinerie : le nom de la pièce et ses options telles que la fiche les écrit */
      var maro = NOMS_MARO[it.handle];
      if (maro) vt = it.variant_title && it.variant_title !== 'Default Title' ? ' <span class="dl-variant">' + it.variant_title.replace(/\s*\/\s*/g, ' · ') + '</span>' : '';
      var pre = it.properties && it.properties['Précommande'] ? '<span class="dl-pre">Précommande, ' + it.properties['Précommande'] + '</span>' : '';
      var titre = tige ? 'Tige ' + tigeFamille(it.product_title).toLowerCase().replace(/(^|\s)\S/g, function (c) { return c.toUpperCase(); }) : maro ? maro : boucleNom(it);
      return '<div class="drawer-line">' + ouvre + img + ferme + '<div class="dl-info"><h4>' + ouvre + titre + ferme + vt + '</h4>' + pre +
        (tige ? sizeSelect(i, size, availableSizes(null, it.handle, ((it.options_with_values || []).find(function (x) { return /couleur/i.test(x.name); }) || {}).value)) : '') +
        '<div class="dl-row">' + qtyCtl(i, it.quantity) + '<div class="dl-price">' + euroTxt(it.final_line_price / 100) + '</div></div></div>' +
        '<button class="dl-remove" data-remove="' + i + '">Retirer</button></div>';
    }).join('') + pending.map(function (p, j) {
      var i = items.length + j;
      var hp = lienFiche(p.id), op = hp ? '<a class="dl-fiche" href="' + hp + '">' : '', fp = hp ? '</a>' : '';
      return '<div class="drawer-line">' + op + '<img class="dl-thumb dl-tige" src="' + (window.cartThumb ? cartThumb(p.img) : p.img) + '" alt="' + p.name + '">' + fp +
        '<div class="dl-info"><h4>' + op + p.name + fp + (p.vlabel && p.name.toLowerCase().indexOf(String(p.vlabel).toLowerCase()) === -1 ? ' <span class="dl-variant">' + p.vlabel + '</span>' : '') + '</h4>' + sizeSelect(i, '', availableSizes(p.id)) +
        '<div class="dl-row"><div class="dl-price">' + euroTxt(p.price) + '</div></div></div>' +
        '<button class="dl-remove" data-remove="' + i + '">Retirer</button></div>';
    }).join('');
    drawerItems.innerHTML = ship + html;
    if (drawerTotal) drawerTotal.textContent = euroTxt(sub);
    if (drawerFoot) drawerFoot.hidden = false;
    var lab = drawerFoot && drawerFoot.querySelector('.drawer-total span'); if (lab) lab.textContent = 'Total';
    var btn = drawerFoot && drawerFoot.querySelector('.btn');
    /* Une tige sans taille : le bouton ne se grise plus, il guide vers la taille
       (sur téléphone, un bouton grisé passe pour un site cassé). */
    if (btn) {
      btn.disabled = false;
      btn.textContent = pending.length ? 'Choisir ma taille' : 'Passer commande';
      if (pending.length) btn.setAttribute('data-guide', '1'); else btn.removeAttribute('data-guide');
    }
    /* Un bouton grise sans explication laisse le client bloque : on dit ce
       qui manque, et on amene la ligne concernee sous ses yeux. */
    if (drawerFoot) {
      var bloc = drawerFoot.querySelector('.drawer-bloc');
      if (!bloc) { bloc = document.createElement('p'); bloc.className = 'drawer-bloc'; drawerFoot.insertBefore(bloc, drawerFoot.firstChild); }
      bloc.textContent = pending.length > 1 ? 'Choisissez la taille de vos tiges pour continuer'
                                            : 'Choisissez la taille de votre tige pour continuer';
      bloc.hidden = pending.length === 0;
    }
    if (pending.length) {
      var todo = drawerItems.querySelector('.dl-size-todo');
      if (todo && drawer && drawer.classList.contains('open')) {
        try { todo.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) { }
      }
    }
    /* boutons express Shopify (Shop Pay, Apple Pay, PayPal), rendus par Liquid, déplacés sous le bouton.
       Le temps qu'un ajout soit confirmé par Shopify, ils sont inertes : un clic
       sur Shop Pay pendant l'envoi partirait avec le panier d'avant. */
    placeExpress();
    var ex = document.getElementById('yolete-express');
    if (ex) { ex.style.display = pending.length ? 'none' : ''; ex.style.pointerEvents = provisoires.length ? 'none' : ''; ex.style.opacity = provisoires.length ? '.55' : ''; }
  }
  /* quantité */
  document.body.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qd]'); if (!b) return;
    var it = items[+b.dataset.qd]; if (!it) return;
    var q = it.quantity + (+b.dataset.d); if (q < 1) q = 0;
    api('/cart/change.js', { id: it.key, quantity: q }).then(refresh).catch(function (err) { say(err && err.description ? err.description : 'Quantité indisponible'); refresh(); });
  });

  /* ---------- choix de taille : ligne en attente -> variante Shopify, ligne Shopify -> autre variante ---------- */
  document.body.addEventListener('change', function (e) {
    var s = e.target.closest('.dl-size'); if (!s || !s.value) return;
    try { onSize(s); } catch (err) { console.error('taille', err); say('Erreur au choix de la taille'); }
  }, true);
  function onSize(s) {
    var i = +s.dataset.sizeFor, size = s.value;
    if (i >= items.length) {
      var p = pending[i - items.length]; if (!p) return;
      var v = tigeVariant(p.id, size);
      if (!v) { say('Cette taille n’est pas disponible'); return; }
      pending.splice(i - items.length, 1);
      var tp = tigeProduct(p.id);
      addVariant(v.id, 1, tp ? ligneProvisoire(tp.prod.handle, v) : null).catch(function (err) { say(err && err.description ? err.description : 'Taille indisponible'); pending.push(p); render(); });
    } else {
      var it = items[i]; if (!it || sizeOf(it) === size) return;
      var prod = BYH[it.handle]; if (!prod) return;
      var col = norm((it.options_with_values || []).find(function (x) { return /couleur/i.test(x.name); }).value);
      var nv = prod.variants.find(function (v) { return norm(v.option1) === col && String(v.option2).replace(/\D/g, '') === size; });
      if (!nv) { say('Cette taille n’est pas disponible'); render(); return; }
      api('/cart/change.js', { id: it.key, quantity: 0 }).then(function () { return api('/cart/add.js', { items: [{ id: nv.id, quantity: it.quantity }] }); }).then(refresh)
        .catch(function (err) { say(err && err.description ? err.description : 'Taille indisponible'); refresh(); });
    }
  }

  /* ---------- passer commande ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('#drawerFoot .btn'); if (!b) return;
    e.preventDefault();
    if (pending.length) {
      var wrap = drawerItems && drawerItems.querySelector('.dl-size-todo'), sel = wrap && wrap.querySelector('.dl-size');
      if (wrap) {
        try { wrap.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (err) {}
        wrap.classList.remove('dl-size-pulse'); void wrap.offsetWidth; wrap.classList.add('dl-size-pulse');
        if (sel) setTimeout(function () { try { sel.focus(); } catch (err) {} }, 350);
      }
      say(pending.length > 1 ? 'Choisissez la taille de vos tiges' : 'Choisissez la taille de votre tige');
      return;
    }
    if (!items.length && !provisoires.length) return;
    /* un ajout encore en route : on attend sa confirmation avant d'ouvrir la commande */
    fileAjout.then(function () { location.href = '/checkout'; });
  });

  /* Sur Shopify, le bandeau de consentement est celui de la boutique : on retire le nôtre. */
  var ck = document.querySelector('.cookies'); if (ck) ck.remove();
  window.__yoleteCart = { tigeVariant: tigeVariant, boucleVariant: boucleVariant, BYH: BYH, pending: pending, items: function () { return items; }, provisoires: function () { return provisoires; }, token: function () { return cartToken; }, api: api, lineThumb: lineThumb, beltThumb: beltThumb };
  /* les boutons express Shopify sont deplaces dans le pied du tiroir avant tout rendu, pour que le composant se dimensionne */
  function placeExpress() { var ex = document.getElementById('yolete-express'); if (ex && drawerFoot && ex.parentNode !== drawerFoot) { ex.hidden = false; ex.className = 'dl-express'; drawerFoot.appendChild(ex); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeExpress); else placeExpress();
  refresh();
})();
